import React, { Component } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment-timezone';
import { withStyles } from '@material-ui/core/styles';

import {
  Paper,
  CircularProgress,
  Typography,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  TableFooter,
  TablePagination,
  TableSortLabel,
} from '@material-ui/core';

const columns = [
  {
    label: 'Name',
    key: 'NAME',
  },
  {
    label: 'Username',
    key: 'USERNAME',
  },
  {
    label: 'Email',
    key: 'EMAIL',
  },
  {
    label: 'Last Updated',
    key: 'UPDATED_AT',
  },
];

class HolrMediaUsersListTable extends Component {
  static propTypes = {
    data: PropTypes.arrayOf(
      PropTypes.shape({
        uuid: PropTypes.string,
        firstName: PropTypes.string,
        lastName: PropTypes.string,
        username: PropTypes.string,
        email: PropTypes.string,
        updatedAt: PropTypes.string,
      }),
    ),
    loading: PropTypes.bool,
    onItemClick: PropTypes.func,
    onRequestSort: PropTypes.func,
    classes: PropTypes.object,
    loadMore: PropTypes.func.isRequired,
    totalCount: PropTypes.number.isRequired,
  }

  static defaultProps = {
    data: [],
    classes: {},
    onItemClick: () => { },
    onRequestSort: () => { },
    loading: false,
  }

  state = {
    page: 0,
    rowsPerPage: 10,
    rowsPageOptions: [],
    order: '',
    orderBy: '',
  };

  handleChangePage = (e, page) => {
    const { loadMore } = this.props;
    const { rowsPerPage } = this.state;

    this.setState({ page });
    loadMore(rowsPerPage);
  }

  handleRequestSort = (property) => {
    const { order, orderBy } = this.state;
    const { onRequestSort } = this.props;
    const isAsc = orderBy === property && order === 'asc';

    this.setState(({
      order: isAsc ? 'desc' : 'asc',
      orderBy: property,
    }));

    onRequestSort(property, isAsc ? 'ASCENDING' : 'DESCENDING');
  };

  renderRows = () => {
    const { data, onItemClick, classes } = this.props;
    const { page, rowsPerPage } = this.state;

    return data
      .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
      .map((user, index) => {
        const {
          uuid,
          fullName,
          username = '-',
          email = '-',
          updatedAt = '-',
        } = user;

        return (
          <TableRow
            hover
            onClick={() => onItemClick(uuid)}
            key={uuid || index}
            classes={{ hover: classes.tableRow }}
          >
            <TableCell className={classes.tableCell}>{fullName}</TableCell>
            <TableCell className={classes.tableCell}>{`@${username}`}</TableCell>
            <TableCell className={classes.tableCell}>{email}</TableCell>
            <TableCell className={classes.tableCell}>{updatedAt ? moment(updatedAt).format('MM/DD/YYYY hh:mm A') : '-'}</TableCell>
          </TableRow>
        );
      });
  }

  renderContent = () => {
    const {
      data,
      loading,
      classes,
    } = this.props;

    switch (true) {
      case loading:
        return (
          <TableRow>
            <TableCell colSpan={6} padding="none" className={classes.loading}>
              <CircularProgress thickness={5} size={80} />
            </TableCell>
          </TableRow>
        );
      case !data.length:
        return (
          <TableRow>
            <TableCell colSpan={6} padding="none" className={classes.loading}>
              <Typography variant="display1">Sorry, seems there&apos;s no content to display</Typography>
            </TableCell>
          </TableRow>
        );
      default:
        return this.renderRows();
    }
  }

  render() {
    const { totalCount, classes } = this.props;
    const {
      page, rowsPerPage, rowsPageOptions, orderBy, order,
    } = this.state;
    return (
      <Paper>
        <Table>
          <TableHead>
            <TableRow>
              {columns.map(column => (
                <TableCell className={classes.tableHead}>
                  <TableSortLabel
                    active={orderBy === column.key}
                    direction={orderBy === column.key ? order : 'asc'}
                    onClick={() => this.handleRequestSort(column.key)}
                  >
                    {column.label}
                  </TableSortLabel>
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {this.renderContent()}
          </TableBody>
          <TableFooter>
            <TableRow>
              <TablePagination
                colSpan={5}
                rowsPerPageOptions={rowsPageOptions}
                rowsPerPage={rowsPerPage}
                page={page}
                count={totalCount}
                SelectProps={{ native: true }}
                onChangePage={this.handleChangePage}
              />
            </TableRow>
          </TableFooter>
        </Table>
      </Paper>
    );
  }
}

export default withStyles(theme => ({
  loading: {
    textAlign: 'center',
    padding: `${theme.spacing.unit * 10}px !important`,
  },
  tableHead: {
    fontWeight: 'bold',
    color: theme.palette.primary.main,
  },
  tableCell: {
    border: 'none',
  },
  tableRow: {
    '&&:hover': {
      backgroundColor: theme.palette.action.hover,
      cursor: 'pointer',
    },
  },
}))(HolrMediaUsersListTable);
